import React, { useMemo, useEffect } from 'react'
import { Container, Button, ComboBox, Label } from '@sencha/ext-modern'
import { useInstData } from 'tyan/public/hooks'

const Capture = props => {
	const { onGetFiles, onClose } = props
	const { setState, me, me: { state: { devices, deviceId } } } = useInstData(null, useMemo(() => ({
		state: { devices: [] },
		currentStream: undefined
	}), []))

	const stopMediaTracks = () => {
		if (typeof me.currentStream !== 'undefined') {
			me.currentStream.getTracks().forEach(track => {
				track.stop()
			})
		}
	}

	const gotDevices = (mediaDevices) => {
		var _devices = []
		mediaDevices.forEach(mediaDevice => {
			if (mediaDevice.kind.match(/^video.*/))
				_devices.push(mediaDevice)
		})
		setState({ devices: _devices })
	}

	const gotVideo = (deviceId) => {
		stopMediaTracks()

		if (!navigator.mediaDevices) {
			onClose && onClose()
			Tyan.pubForm.showError("没有可用的摄像头，请检查设备或与管理员联系!")
			return
		}
		const videoConstraints = {}
		if (!deviceId)
			videoConstraints.facingMode = 'environment'
		else
			videoConstraints.deviceId = { exact: deviceId }
		const constraints = {
			video: videoConstraints,
			audio: false
		}
		const video = document.getElementById('video')
		navigator.mediaDevices
			.getUserMedia(constraints)
			.then(stream => {
				me.currentStream = stream
				video.srcObject = stream
				return navigator.mediaDevices.enumerateDevices()
			})
			.then(gotDevices)
			.catch(error => {
				onClose && onClose()
				Tyan.pubForm.showError(error.toString().includes("Permission") ? '没有使用摄像头的权限，请检查浏览器设置！' : error)
				console.error(error)
			})
	}

	const getPhoto = () => {
		const video = document.getElementById('video')
		if (typeof video == 'undefined') return

		// 在这里处理拍照，拍照后显示，成功获取内容后 使用File数组回调onGetFiles，
		// 如: cavas.toBlob(blob => onGetFiles[new File(blob, `${Ext.Date.format(new Date(), 'YmdHisu')}.jpg`)], 'image/jpeg', 0.95)
		const cavas = document.createElement("canvas")
		cavas.width = video.offsetWidth
		cavas.height = video.offsetHeight
		const ctx = cavas.getContext('2d')
		var imageWidth = video.offsetWidth, imageHeight = video.offsetHeight
		ctx.drawImage(video, 0, 0, imageWidth, imageHeight)
		cavas.toBlob(blob => {
			const file = new File([blob], `${Ext.Date.format(new Date(), 'YmdHisu')}.jpg`, { type: 'image/jpeg' })
			onGetFiles([file])
			onClose && onClose()
		}, 'image/jpeg', 0.95)
	}

	const handleChange = (v) => {
		setState({ deviceId: v._value })
	}

	useEffect(() => {
		if (!deviceId) return
		gotVideo(deviceId)
	}, [deviceId])

	useEffect(() => {
		gotVideo()

		return () => {
			stopMediaTracks()
		}
	}, [])

	return <Container margin='0 20 20 20' {...props}>
		{devices.length == 0 && <Label html='正在加载摄像头，请稍等...' />}
		<div><video id="video" autoPlay playsInline ></video></div>
		{devices.length > 0 && <Container layout={{ type: "hbox", pack: "start" }} >
			<Label html='摄像头：' style={{ marginTop: '8px' }} />
			<ComboBox queryMode='local' onChange={handleChange} value={deviceId ? deviceId : devices[devices.length - 1].deviceId}
				options={devices.map(o => [o.deviceId, o.label])} />
			<Button docked='right' iconCls='x-fa fa-camera' handler={() => getPhoto()} text='拍照' />
		</Container>}
	</Container>
}

export default Capture